import { Controller } from '@hotwired/stimulus'
import flatpickr from 'flatpickr'
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect'

export default class extends Controller {
  static values = {
    defaultDate: String,
  }

  connect() {
    const options = {
      dateFormat: 'Y-m-d',
      altInput: true,
      altFormat: 'F Y',
      allowInput: false,
      disableMobile: true,
      plugins: [
        new monthSelectPlugin({
          shorthand: false,
          dateFormat: 'Y-m-d',
          altFormat: 'F Y',
        }),
      ],
    }

    if (this.hasDefaultDateValue) {
      options.defaultDate = this.defaultDateValue
    }

    this.flatpickr = flatpickr(this.element, options)

    if (this.flatpickr.altInput) {
      this.flatpickr.altInput.inputMode = 'none'
      this.flatpickr.altInput.readOnly = true
      this.flatpickr.altInput.style.fontSize = '16px'
    }

    this._form = this.element.closest('form')
    this._submitHandler = this._adjustDateToMidMonth.bind(this)
    this._form?.addEventListener('submit', this._submitHandler)
  }

  disconnect() {
    if (this.flatpickr) {
      this.flatpickr.destroy()
    }
    this._form?.removeEventListener('submit', this._submitHandler)
  }

  _adjustDateToMidMonth() {
    const value = this.element.value
    if (!value) return
    const [year, month] = value.split('-').map(Number)
    const lastDay = new Date(year, month, 0).getDate()
    const today = new Date()
    const day = Math.min(today.getDate(), lastDay)
    this.element.value = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
  }
}
